import { App } from '../../pkg';
import FPS from './fps';

interface Looper {
  fps: FPS;
  start: () => void;
  requestRender: () => void;
}

export const makeLooper = (app: App): Looper => {
  const fps = new FPS();
  let dirty = true;
  let started = false;
  let frameHandle: number | null = null;

  const scheduleFrame = () => {
    if (frameHandle !== null) {
      return;
    }
    frameHandle = window.requestAnimationFrame(loop);
  };

  const loop = () => {
    frameHandle = null;
    if (!dirty) {
      return;
    }

    dirty = false;
    fps.render();
    app.render();

    if (dirty) {
      scheduleFrame();
    }
  };

  const looper = {
    fps,
    start: function () {
      if (started) {
        return;
      }
      started = true;
      scheduleFrame();
    },
    requestRender: function () {
      dirty = true;
      if (started) {
        scheduleFrame();
      }
    },
  };
  return looper;
};
